<template>
  <div class="hero">
    <div class="hero__container container">
      <div class="hero__grid">
        <button
          class="hero__cta"
          v-for="(image,i) in images"
          :key="i">
          <picture class="hero__picture">
            <img 
              class="hero__image"
              :src="image" 
              alt>
          </picture>
        </button>
      </div>
    </div>
  </div>

</template>


<script>
export default {
  name: 'Hero',

  props: {
    figures: {
      type: Array
    }
  },

  computed: {
    isMobile(){
      return window.screen.width < 744
    },

    images(){
      return this.figures.slice(0, this.isMobile ? 1 : 5);
    }
  }
}
</script>
